"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "%" */
    h20Text: ReactNode;
    /** Detected variants: "Years Experience" | "Patients Treated Worldwide" | "Success Rate" | "Cardiology Services" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "counter-item-seven flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "sub-title" */
    p0ClassName?: string;
    /** Detected variants: "isVisible && <CountUp end={12} duration={2} />" | "isVisible && <CountUp end={15000} duration={2} />" | "isVisible && <CountUp end={98} duration={2} />" | "isVisible && <CountUp end={20} duration={2} />" */
    div0h20Expr0: ReactNode;
};

type AboutSectionAvatarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" */
    src: string;
    /** Detected variants: "avatar" */
    className?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "img-fluid rounded-circle" */
    imageWithBasePath0ClassName?: string;
};

type AboutSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "We are equipped with the latest diagnostic and treatment facilities." | "Ensuring accurate diagnoses and effective treatments." | "Unique needs and create personalized treatment plans." */
    liText: ReactNode;
};
export type HomeSevenAboutSectionGeneratedProps = {
    divDiv0H20H2Props?: Partial<ComponentProps<"h2">> | ((item: AboutSection36sItem) => Partial<ComponentProps<"h2">>);
    sectionDiv0Div0Div0ClassName?: string;
    sectionDiv0Div1ClassName?: string;
    /** Default: "Cardiology Health Care" */
    sectionDiv0Div1Div0Div0Button0ButtonDataText?: string;
    sectionDiv0Div1Div0Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div1Div0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "about" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-04.jpg" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about" */
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-05.jpg" */
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "About Us" */
    sectionDiv0Div1Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "Compassionate patient care to deliver the" */
    sectionDiv0Div1Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div1Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div1Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "best outcomes." */
    sectionDiv0Div1Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "With over two decades of excellence in cardiac care, We are at the forefront of cardiovascular medicine. Our team of highly skilled cardiologists combines." */
    sectionDiv0Div1Div1Div0Div0P0PText?: ReactNode;
    /** Default: "0.2s" */
    sectionDiv0Div1Div1Div0Div1DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div1Div0Div1DivDataWowDuration?: string;
    /** Default: "mission" */
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/mission-02.svg" */
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Mission" */
    sectionDiv0Div1Div1Div0Div1Div1H30H3Text?: ReactNode;
    sectionDiv0Div1Div1Div0Div1Div1H30H3Visible?: boolean;
    sectionDiv0Div1Div1Div0Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "To nurture healthy, happy, and confident children by combining medical excellence with empathy and understanding." */
    sectionDiv0Div1Div1Div0Div1Div1P0PText?: ReactNode;
    /** Default: "More then 4.9K clients reviews" */
    sectionDiv0Div1Div1Div0Div2Div0P0PText?: ReactNode;
    /** Default: "all_routes.aboutUs" */
    sectionDiv0Div1Div1Div0Div2Link0LinkHref?: string;
    /** Default: "Know More" */
    sectionDiv0Div1Div1Div0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div1Div1Div0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div1Div1Div0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-04.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection36s: AboutSection36sItem[];
    aboutSectionAvatars: AboutSectionAvatarsItem[];
    aboutSectionUls: AboutSectionUlsItem[];
    aboutSection36sItemWrapper?: (item: AboutSection36sItem, content: ReactNode) => ReactNode;
    aboutSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection36sH2Visible?: boolean;
    aboutSection36sH2Renderer?: (item: AboutSection36sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection36sH2Props?: Partial<ComponentProps<"h2">> | ((item: AboutSection36sItem) => Partial<ComponentProps<"h2">>);
    aboutSectionAvatarsItemWrapper?: (item: AboutSectionAvatarsItem, content: ReactNode) => ReactNode;
    aboutSectionAvatarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageVisible?: boolean;
    aboutSectionAvatarsImageRenderer?: (item: AboutSectionAvatarsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionUlsItemWrapper?: (item: AboutSectionUlsItem, content: ReactNode) => ReactNode;
    aboutSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSevenAboutSectionGenerated: FC<HomeSevenAboutSectionGeneratedProps> = ({
    sectionDiv0Div1Div0Div0Button0ButtonDataText = "Cardiology Health Care",
    sectionDiv0Div1Div0Div0Button0ButtonVisible,
    sectionDiv0Div1Div0Div0Button0ButtonRenderer,
    sectionDiv0Div1Div0Div0Button0ButtonProps,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-04.jpg",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-05.jpg",
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div1Div1Div0Div0H20H2Text = "Compassionate patient care to deliver the",
    sectionDiv0Div1Div1Div0Div0H20H2Visible,
    sectionDiv0Div1Div1Div0Div0H20H2Renderer,
    sectionDiv0Div1Div1Div0Div0H20H2Props,
    sectionDiv0Div1Div1Div0Div0H20Span0SpanText = "best outcomes.",
    sectionDiv0Div1Div1Div0Div0P0PText = "With over two decades of excellence in cardiac care, We are at the forefront of cardiovascular medicine. Our team of highly skilled cardiologists combines.",
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageAlt = "mission",
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/mission-02.svg",
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Div1Div1H30H3Text = "Our Mission",
    sectionDiv0Div1Div1Div0Div1Div1H30H3Visible,
    sectionDiv0Div1Div1Div0Div1Div1H30H3Renderer,
    sectionDiv0Div1Div1Div0Div1Div1H30H3Props,
    sectionDiv0Div1Div1Div0Div1Div1P0PText = "To nurture healthy, happy, and confident children by combining medical excellence with empathy and understanding.",
    sectionDiv0Div1Div1Div0Div1DivDataWowDelay = "0.2s",
    sectionDiv0Div1Div1Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div1Div1Div0Div2Div0P0PText = "More then 4.9K clients reviews",
    sectionDiv0Div1Div1Div0Div2Link0LinkHref = "all_routes.aboutUs",
    sectionDiv0Div1Div1Div0Div2Link0LinkText = "Know More",
    sectionDiv0Div1Div1Div0Div2Link0LinkVisible,
    sectionDiv0Div1Div1Div0Div2Link0LinkRenderer,
    sectionDiv0Div1Div1Div0Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-bg-04.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0H20H2Props,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div1ClassName,
    aboutSection36s,
    aboutSectionAvatars,
    aboutSectionUls,
    aboutSection36sItemWrapper,
    aboutSection36sRenderer,
    aboutSection36sH2Visible,
    aboutSection36sH2Renderer,
    aboutSection36sH2Props,
    aboutSectionAvatarsItemWrapper,
    aboutSectionAvatarsRenderer,
    aboutSectionAvatarsImageVisible,
    aboutSectionAvatarsImageRenderer,
    aboutSectionAvatarsImageProps,
    aboutSectionUlsItemWrapper,
    aboutSectionUlsRenderer,
}) => {
    return (
        <section className="about-section-seven section">
            <div className="container">
                <div className="counter-sec section-bottom">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            aboutSection36s,
                            (item: AboutSection36sItem) => (
                                <div className={item.className ?? "col-xl-3 col-sm-6 d-flex"} key={item.key}>
                                    <div className={item.div0ClassName ?? "counter-item-seven flex-fill"}>
                                        {renderItemNode(aboutSection36sH2Visible, aboutSection36sH2Renderer, item, (
                                            <h2 {...(typeof aboutSection36sH2Props === "function" ? aboutSection36sH2Props(item) : (aboutSection36sH2Props ?? {}))} {...(typeof divDiv0H20H2Props === "function" ? divDiv0H20H2Props(item) : (divDiv0H20H2Props ?? {}))}>{item.h20Text}</h2>
                                        ))}
                                        <p className={item.p0ClassName ?? "sub-title"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            aboutSection36sItemWrapper,
                            aboutSection36sRenderer
                        )}
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="about-img-seven">
                            <div className="about-img-01">
                                {renderNode(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="about-img-02">
                                {renderNode(sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageAlt} {...(sectionDiv0Div1Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div1Div0Div0Button0ButtonVisible, sectionDiv0Div1Div0Div0Button0ButtonRenderer, (
                                <button className="animate-button" data-text={sectionDiv0Div1Div0Div0Button0ButtonDataText} {...(sectionDiv0Div1Div0Div0Button0ButtonProps ?? {})}>
                                    <p className="button-text" />
                                    <span className="button-circle" />
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content-seven">
                            <div className="section-header section-header-seven">
                                <div className="section-sub-title">{sectionDiv0Div1Div1Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div1Div1Div0Div0H20H2Visible, sectionDiv0Div1Div1Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div1Div1Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div1Div1Div0Div0H20H2Text}
                                        {" "}
                                        <span>{sectionDiv0Div1Div1Div0Div0H20Span0SpanText}</span>
                                    </h2>
                                ))}
                                <p>{sectionDiv0Div1Div1Div0Div0P0PText}</p>
                            </div>
                            <div className="mission-item-five wow fadeInUp" data-wow-delay={sectionDiv0Div1Div1Div0Div1DivDataWowDelay} data-wow-duration={sectionDiv0Div1Div1Div0Div1DivDataWowDuration}>
                                <div className="mission-icon">
                                    {renderNode(sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div1Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div>
                                    {renderNode(sectionDiv0Div1Div1Div0Div1Div1H30H3Visible, sectionDiv0Div1Div1Div0Div1Div1H30H3Renderer, (
                                        <h3 className="custom-title" {...(sectionDiv0Div1Div1Div0Div1Div1H30H3Props ?? {})}>{sectionDiv0Div1Div1Div0Div1Div1H30H3Text}</h3>
                                    ))}
                                    <p>{sectionDiv0Div1Div1Div0Div1Div1P0PText}</p>
                                </div>
                            </div>
                            <ul className="about-list-two">
                                {renderCollectionNode(
                                    aboutSectionUls,
                                    (item: AboutSectionUlsItem) => (
                                        <li key={item.key}>{item.liText}</li>
                                    ),
                                    aboutSectionUlsItemWrapper,
                                    aboutSectionUlsRenderer
                                )}
                            </ul>
                            <div className="view-more">
                                {renderNode(sectionDiv0Div1Div1Div0Div2Link0LinkVisible, sectionDiv0Div1Div1Div0Div2Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div1Div1Div0Div2Link0LinkHref} className="btn btn-white theme-7-btn" {...(sectionDiv0Div1Div1Div0Div2Link0LinkProps ?? {})}>
                                        {sectionDiv0Div1Div1Div0Div2Link0LinkText}
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-3" />
                                        </span>
                                    </SmartLink>
                                ))}
                                <div className="about-rating">
                                    <div className="avatar-list-stacked avatar-group-lg">
                                        {renderCollectionNode(
                                            aboutSectionAvatars,
                                            (item: AboutSectionAvatarsItem) => (
                                                <span className={item.className ?? "avatar"} key={item.key}>
                                                    {renderItemNode(aboutSectionAvatarsImageVisible, aboutSectionAvatarsImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "patient"} className={item.imageWithBasePath0ClassName ?? "img-fluid rounded-circle"} {...(typeof aboutSectionAvatarsImageProps === "function" ? aboutSectionAvatarsImageProps(item) : (aboutSectionAvatarsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </span>
                                            ),
                                            aboutSectionAvatarsItemWrapper,
                                            aboutSectionAvatarsRenderer
                                        )}
                                    </div>
                                    <p>{sectionDiv0Div1Div1Div0Div2Div0P0PText}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="about-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSevenAboutSectionGenerated;
